import { Select as SelectPrimitive } from '@base-ui/react/select';
import type { ComponentProps } from 'react';

import ChevronDownIcon from '@/assets/svg/chevron-down.svg?react';
import { cn } from '@/lib/utils';

export type SelectScrollUpButtonProps = ComponentProps<typeof SelectPrimitive.ScrollUpArrow>;

const SelectScrollUpButton = ({ className, ...props }: SelectScrollUpButtonProps) => {
  return (
    <SelectPrimitive.ScrollUpArrow
      data-slot="select-scroll-up-button"
      className={cn(
        'top-0 z-10 flex w-full cursor-default items-center justify-center bg-white py-1',
        '[&_svg:not([class*="size-"])]:size-4',
        className,
      )}
      {...props}
    >
      <ChevronDownIcon className="size-4 rotate-180" />
    </SelectPrimitive.ScrollUpArrow>
  );
};

export default SelectScrollUpButton;
